export const classes = {
  cell: 'cursor-pointer text-sm text-grey-7 dark:text-mauve-2 font-medium py-4 bg-grey-1 dark:bg-white/[0.06] border-b border-grey-3 dark:border-white/10',
  content: 'inline-flex items-center',
  label: 'cursor-pointer select-none',
  chevron: 'cursor-pointer ml-1',
};
